import React from "react";
import "./Store_Product_Card.css";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../../utils/common";

const Store_Product_Card = ({ img, name, id }) => {
  const navigate = useNavigate();

  return (
    <div
      className="Store_Product_Card"
      onClick={() => navigate(`/vendor-page/${encodeId(id)}`)}
    >
      <div className="bg_img_holder">
        <img
          src="/assets/Image/Homepage/new_arrval/bg_img.png"
          className="bg_img"
        />

        <div className="prod_img_holder">
          <img src={img} className="prod_img" />
        </div>
        <div className="text_holder">
          <p className="prod_name">{name}</p>
        </div>
      </div>
    </div>
  );
};

export default Store_Product_Card;
